
function Profile() {
  return (
    <h1>Dashboard/Profile</h1>
  )
}

export default Profile